export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ISO8601DateTime: any;
  AvatarUrl: any;
  LogoUrl: any;
  Email: any;
  Percentage: any;
  Link: any;
  Upload: any;
  PictureLink: any;
};

export type AffiliationResult = {
  __typename?: 'AffiliationResult';
  earlyAffiliationWarning: Scalars['Boolean'];
  assignmentActivityStartsAt: Scalars['ISO8601DateTime'];
};

export enum AntivirusStatus {
  ScanInProgress = 'SCAN_IN_PROGRESS',
  AttachmentAccepted = 'ATTACHMENT_ACCEPTED',
  AttachmentRejected = 'ATTACHMENT_REJECTED'
}

export type Appointment = {
  __typename?: 'Appointment';
  id: Scalars['ID'];
  from: Scalars['ISO8601DateTime'];
  conversation?: Maybe<Conversation>;
};

export type AppointmentClaim = {
  __typename?: 'AppointmentClaim';
  id: Scalars['ID'];
  resolvedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum AppointmentListScope {
  ConfirmedBySelf = 'CONFIRMED_BY_SELF',
  Upcoming = 'UPCOMING',
  Past = 'PAST',
  Next = 'NEXT',
  All = 'ALL'
}

export type AppointmentReview = {
  appointmentStatus: AppointmentStatus;
  answer1: Scalars['Int'];
  answer2: Scalars['Int'];
  answer3: Scalars['Int'];
};

export type AppointmentReviewFromProfessional = AppointmentReview & {
  __typename?: 'AppointmentReviewFromProfessional';
  appointmentStatus: AppointmentStatus;
  answer1: Scalars['Int'];
  answer2: Scalars['Int'];
  answer3: Scalars['Int'];
  messageForHr?: Maybe<Scalars['String']>;
};

export type AppointmentReviewFromStudent = AppointmentReview & {
  __typename?: 'AppointmentReviewFromStudent';
  appointmentStatus: AppointmentStatus;
  answer1: Scalars['Int'];
  answer2: Scalars['Int'];
  answer3: Scalars['Int'];
  wantToBeRecontacted?: Maybe<Scalars['Boolean']>;
  aspiration?: Maybe<StudentAspiration>;
};

export enum AppointmentStatus {
  AwaitingReview = 'AWAITING_REVIEW',
  TookPlace = 'TOOK_PLACE',
  Cancelled = 'CANCELLED',
  DidNotShowUp = 'DID_NOT_SHOW_UP',
  ForgotToGo = 'FORGOT_TO_GO',
  Rescheduled = 'RESCHEDULED',
  WasNotScheduled = 'WAS_NOT_SCHEDULED',
  Unbooked = 'UNBOOKED',
  Other = 'OTHER'
}

export type AssignmentParticipant = {
  __typename?: 'AssignmentParticipant';
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  avatar?: Maybe<Scalars['AvatarUrl']>;
  affiliatedAt: Scalars['ISO8601DateTime'];
  firstConversationAt?: Maybe<Scalars['ISO8601DateTime']>;
  conversationCount?: Maybe<Scalars['Int']>;
  conversationWithoutReplyFromStudentCount?: Maybe<Scalars['Int']>;
  firstAppointmentAt?: Maybe<Scalars['ISO8601DateTime']>;
  appointmentWithFeedbackCount?: Maybe<Scalars['Int']>;
  pendingAppointmentCount?: Maybe<Scalars['Int']>;
  status: StudentStatus;
};


export type AssignmentParticipantAvatarArgs = {
  version?: Maybe<PictureVersion>;
};

export enum AssignmentsListScope {
  Current = 'CURRENT',
  Past = 'PAST',
  Upcoming = 'UPCOMING'
}


export type CoachAssignment = {
  __typename?: 'CoachAssignment';
  id: Scalars['ID'];
  name: Scalars['String'];
  schoolName: Scalars['String'];
  campusName: Scalars['String'];
  diplomaLevel: DiplomaLevel;
  startsAt: Scalars['ISO8601DateTime'];
  endsAt: Scalars['ISO8601DateTime'];
  size: Scalars['Int'];
  dataRecalculatedAt: Scalars['ISO8601DateTime'];
  participants: Array<AssignmentParticipant>;
  affiliatedStudentCount: Scalars['Int'];
  studentWithConversationCount?: Maybe<Scalars['Int']>;
  studentWithAppointmentWithFeedbackCount?: Maybe<Scalars['Int']>;
};

export enum CommunicationLanguage {
  French = 'FRENCH',
  English = 'ENGLISH'
}

export type Company = {
  __typename?: 'Company';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  companySize: CompanySize;
  lastReportGeneratedAt?: Maybe<Scalars['ISO8601DateTime']>;
  companySector: Scalars['String'];
  companyLogo?: Maybe<Scalars['LogoUrl']>;
  publishedEmployeesCount: Scalars['Int'];
  employeePackSize: Scalars['Int'];
  activeProfilePercentage: Scalars['Percentage'];
  customAttributesSet: CustomAttributesSet;
  employees: Array<CompanyEmployee>;
  archivedEmployees: Array<CompanyEmployee>;
  createdAt: Scalars['ISO8601DateTime'];
};

export type CompanyEmployee = {
  __typename?: 'CompanyEmployee';
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  jobTitle?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['AvatarUrl']>;
  companyAttribute1?: Maybe<Scalars['String']>;
  companyAttribute2?: Maybe<Scalars['String']>;
  companyAttribute3?: Maybe<Scalars['String']>;
  visibleInSearch: Scalars['Boolean'];
  status: EmployeeStatus;
  lastInvitationEmailSentAt: Scalars['ISO8601DateTime'];
  canReceiveInvitationReminder: Scalars['Boolean'];
  canPublish: Scalars['Boolean'];
  canApprove: Scalars['Boolean'];
  canUnpublish: Scalars['Boolean'];
  canArchive: Scalars['Boolean'];
};


export type CompanyEmployeeAvatarArgs = {
  version?: Maybe<PictureVersion>;
};

export type CompanyEmployeeAppointment = {
  __typename?: 'CompanyEmployeeAppointment';
  id: Scalars['ID'];
  from: Scalars['ISO8601DateTime'];
  professional?: Maybe<CompanyEmployee>;
  student?: Maybe<PublicStudentProfile>;
  reviewFromProfessional?: Maybe<AppointmentReviewFromProfessional>;
  reviewFromStudent?: Maybe<AppointmentReviewFromStudent>;
};

export type CompanyEmployeeAppointmentConnection = {
  __typename?: 'CompanyEmployeeAppointmentConnection';
  edges: Array<CompanyEmployeeAppointmentEdge>;
  nodes: Array<CompanyEmployeeAppointment>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type CompanyEmployeeAppointmentEdge = {
  __typename?: 'CompanyEmployeeAppointmentEdge';
  cursor: Scalars['String'];
  node?: Maybe<CompanyEmployeeAppointment>;
};

export type CompanyReport = {
  __typename?: 'CompanyReport';
  companyId: Scalars['ID'];
  from: Scalars['ISO8601DateTime'];
  to: Scalars['ISO8601DateTime'];
  lastUpdatedAt: Scalars['ISO8601DateTime'];
  newConversationCount: Scalars['Int'];
  contactedEmployeesCount: Scalars['Int'];
  responseRate: Scalars['Percentage'];
  appointmentCount: Scalars['Int'];
  publishedEmployeeCount: Scalars['Int'];
  publishedEmployeesWithAppointmentRate: Scalars['Percentage'];
  employeesViewCount: Scalars['Int'];
  uniqueProfileViewsFromStudents: Scalars['Int'];
  studentsSeeingThemselvesInTheSectorRate: Scalars['Percentage'];
  wishCount: Scalars['Int'];
  likeCount: Scalars['Int'];
  bestProfiles: Array<CompanyReportTopEmployees>;
};


export type CompanyReportBestProfilesArgs = {
  limit?: Maybe<Scalars['Int']>;
};

export enum CompanyReportRange {
  ThisMonth = 'THIS_MONTH',
  LastMonth = 'LAST_MONTH',
  FromTheBeginning = 'FROM_THE_BEGINNING'
}

export type CompanyReportTopEmployees = {
  __typename?: 'CompanyReportTopEmployees';
  id: Scalars['ID'];
  avatar?: Maybe<Scalars['AvatarUrl']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  jobTitle: Scalars['String'];
  appointmentCount: Scalars['Int'];
  medal: Scalars['Int'];
};

export type CompanySector = {
  __typename?: 'CompanySector';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum CompanySize {
  OnlyOne = 'ONLY_ONE',
  Under_10 = 'UNDER_10',
  Under_50 = 'UNDER_50',
  Under_200 = 'UNDER_200',
  Under_500 = 'UNDER_500',
  Under_1000 = 'UNDER_1000',
  Under_5000 = 'UNDER_5000',
  Under_10000 = 'UNDER_10000',
  Over_10000 = 'OVER_10000',
  Unknown = 'UNKNOWN'
}

export type Conversation = {
  __typename?: 'Conversation';
  id: Scalars['ID'];
  createdAt: Scalars['ISO8601DateTime'];
  lastMessage?: Maybe<Message>;
  messages: Array<Message>;
  appointmentClaims: Array<AppointmentClaim>;
  professional?: Maybe<PublicProfessionalProfile>;
  student?: Maybe<PublicStudentProfile>;
};

export type ConversationConnection = {
  __typename?: 'ConversationConnection';
  edges: Array<ConversationEdge>;
  nodes: Array<Conversation>;
  pageInfo: PageInfo;
};

export type ConversationEdge = {
  __typename?: 'ConversationEdge';
  cursor: Scalars['String'];
  node?: Maybe<Conversation>;
};

export type CustomAttributesSet = {
  __typename?: 'CustomAttributesSet';
  customEmployeeAttribute1?: Maybe<Scalars['String']>;
  companyAttributeValues1: Array<Scalars['String']>;
  customEmployeeAttribute2?: Maybe<Scalars['String']>;
  companyAttributeValues2: Array<Scalars['String']>;
  customEmployeeAttribute3?: Maybe<Scalars['String']>;
  companyAttributeValues3: Array<Scalars['String']>;
};

export enum DiplomaLevel {
  L1 = 'L1',
  L2 = 'L2',
  L3 = 'L3',
  M1 = 'M1',
  M2 = 'M2',
  Phd = 'PHD',
  Other = 'OTHER'
}

export enum DiplomaType {
  Unknown = 'UNKNOWN',
  HighSchool = 'HIGH_SCHOOL',
  Bts = 'BTS',
  Dut = 'DUT',
  Technical = 'TECHNICAL',
  Cpge = 'CPGE',
  Bachelor = 'BACHELOR',
  Master = 'MASTER',
  Phd = 'PHD'
}

export type Education = {
  __typename?: 'Education';
  id: Scalars['ID'];
  startsAt?: Maybe<Scalars['ISO8601DateTime']>;
  endsAt: Scalars['ISO8601DateTime'];
  diplomaType: DiplomaType;
  diplomaTitle?: Maybe<Scalars['String']>;
  schoolName: Scalars['String'];
};


export enum EmployeeStatus {
  Invited = 'INVITED',
  InvitedMultipleTimes = 'INVITED_MULTIPLE_TIMES',
  IncompleteProfile = 'INCOMPLETE_PROFILE',
  CompleteProfile = 'COMPLETE_PROFILE',
  Approved = 'APPROVED',
  Active = 'ACTIVE',
  AtRisk = 'AT_RISK',
  Inactive = 'INACTIVE',
  Hibernated = 'HIBERNATED',
  Unpublished = 'UNPUBLISHED',
  Archived = 'ARCHIVED',
  Anonymized = 'ANONYMIZED'
}

export type Fdr = {
  __typename?: 'FDR';
  id: Scalars['ID'];
  operationName: Scalars['String'];
};

export type FdrConfigurationSuccess = {
  __typename?: 'FDRConfigurationSuccess';
  fdrCoachLink: Scalars['Link'];
};




export type Message = {
  __typename?: 'Message';
  attachment?: Maybe<MessageAttachment>;
  createdAt: Scalars['ISO8601DateTime'];
  fromSystem: Scalars['Boolean'];
  id: Scalars['ID'];
  seenAt?: Maybe<Scalars['ISO8601DateTime']>;
  sender?: Maybe<SchoolCoach | PublicProfessionalProfile | PublicStudentProfile>;
  status: MessageLocalStatus;
  text: Scalars['String'];
};

export type MessageAttachment = {
  __typename?: 'MessageAttachment';
  name?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  scannedByAntivirus?: Maybe<AntivirusStatus>;
};

export enum MessageLocalStatus {
  Delivering = 'DELIVERING',
  Error = 'ERROR',
  Delivered = 'DELIVERED'
}

export type MjgEmployee = {
  __typename?: 'MJGEmployee';
  id: Scalars['ID'];
  firstName: Scalars['String'];
  avatar: Scalars['AvatarUrl'];
  jobTitle: Scalars['String'];
  funSentence?: Maybe<Scalars['String']>;
};


export type MjgEmployeeAvatarArgs = {
  version?: Maybe<PictureVersion>;
};

export type Mutation = {
  __typename?: 'Mutation';
  inviteEmployee: Scalars['Boolean'];
  approveEmployee: Scalars['Boolean'];
  publishEmployee: Scalars['Boolean'];
  sendEmployeeInvitationEmail: Scalars['Boolean'];
  unpublishEmployee: Scalars['Boolean'];
  archiveEmployee: Scalars['Boolean'];
  createContractualFdr: FdrConfigurationSuccess;
  configureContractualAssignment: Scalars['Boolean'];
  affiliateToAssignment: AffiliationResult;
  updateCompany: Scalars['Boolean'];
  updateCustomAttribute: Scalars['Boolean'];
  updateContractualAssignment: Scalars['Boolean'];
  desafilliateStudentFromAssignment: Scalars['Boolean'];
  sendMessage?: Maybe<Message>;
};


export type MutationInviteEmployeeArgs = {
  companyId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  companyAttribute1?: Maybe<Scalars['String']>;
  companyAttribute2?: Maybe<Scalars['String']>;
  companyAttribute3?: Maybe<Scalars['String']>;
};


export type MutationApproveEmployeeArgs = {
  employeeId: Scalars['ID'];
};


export type MutationPublishEmployeeArgs = {
  employeeId: Scalars['ID'];
};


export type MutationSendEmployeeInvitationEmailArgs = {
  employeeId: Scalars['ID'];
};


export type MutationUnpublishEmployeeArgs = {
  employeeId: Scalars['ID'];
};


export type MutationArchiveEmployeeArgs = {
  employeeId: Scalars['ID'];
};


export type MutationCreateContractualFdrArgs = {
  schoolName: Scalars['String'];
  diplomaLevel: Array<DiplomaLevel>;
  campusName: Scalars['String'];
  customIdentifier?: Maybe<Scalars['String']>;
  supervisorEmail?: Maybe<Scalars['String']>;
  startsAt: Scalars['ISO8601DateTime'];
  endsAt: Scalars['ISO8601DateTime'];
  academicYear: Scalars['String'];
  numberOfMandatoryAppointmentsPerStudent: Scalars['Int'];
  appointmentBonusThreshold1?: Maybe<Scalars['Int']>;
  appointmentBonusThreshold2?: Maybe<Scalars['Int']>;
  emailReminderActivated: Scalars['Boolean'];
  emailReminderWeeklyRate?: Maybe<Scalars['Int']>;
  emailReminderLanguage?: Maybe<CommunicationLanguage>;
  conversationBonusActivated: Scalars['Boolean'];
  conversationBonusMessageCount?: Maybe<Scalars['Int']>;
  conversationBonusDeadline?: Maybe<Scalars['Int']>;
  conversationPenaltyActivated: Scalars['Boolean'];
  description: Scalars['String'];
};


export type MutationConfigureContractualAssignmentArgs = {
  fdrId: Scalars['ID'];
  name: Scalars['String'];
  size: Scalars['Int'];
  emailLanguage: CommunicationLanguage;
};


export type MutationAffiliateToAssignmentArgs = {
  assignmentAffiliationToken: Scalars['String'];
};


export type MutationUpdateCompanyArgs = {
  companyId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<CompanySize>;
  sectorId?: Maybe<Scalars['ID']>;
};


export type MutationUpdateCustomAttributeArgs = {
  companyId: Scalars['ID'];
  customAttributeNumber: Scalars['Int'];
  customEmployeeAttribute?: Maybe<Scalars['String']>;
  companyAttributeValues: Array<Maybe<Scalars['String']>>;
};


export type MutationUpdateContractualAssignmentArgs = {
  assignmentId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
};


export type MutationDesafilliateStudentFromAssignmentArgs = {
  participationId: Scalars['ID'];
  assignmentId: Scalars['ID'];
};


export type MutationSendMessageArgs = {
  conversationId: Scalars['ID'];
  text: Scalars['String'];
  fromMessageTemplateId?: Maybe<Scalars['ID']>;
  attachment?: Maybe<Scalars['Upload']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PartnerSchool = {
  __typename?: 'PartnerSchool';
  id: Scalars['ID'];
  name: Scalars['String'];
  configurableFdrs: Array<Fdr>;
};



export enum PictureVersion {
  Original = 'ORIGINAL',
  Small = 'SMALL',
  Smaller = 'SMALLER',
  Thumb = 'THUMB',
  Blurred = 'BLURRED'
}

export type PrivateData = {
  __typename?: 'PrivateData';
  id: Scalars['ID'];
  profileType: PrivateDataProfileType;
  firstName: Scalars['String'];
  avatar?: Maybe<Scalars['AvatarUrl']>;
  unreadMessageCount: Scalars['Int'];
};

export enum PrivateDataProfileType {
  Mentor = 'MENTOR',
  Employee = 'EMPLOYEE',
  Student = 'STUDENT'
}

export type PrivateProfile = {
  id: Scalars['ID'];
  avatar?: Maybe<Scalars['AvatarUrl']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};


export type PrivateProfileAvatarArgs = {
  version?: Maybe<PictureVersion>;
};

export type PrivateStudentMissions = {
  __typename?: 'PrivateStudentMissions';
  previous: StudentMissions;
  current?: Maybe<StudentMissions>;
  next?: Maybe<StudentMissions>;
};

export type PrivateStudentProfile = PrivateProfile & {
  __typename?: 'PrivateStudentProfile';
  id: Scalars['ID'];
  avatar?: Maybe<Scalars['AvatarUrl']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  signupAt: Scalars['ISO8601DateTime'];
  lastUpdatedAt: Scalars['ISO8601DateTime'];
  profileCompletionStatus: Scalars['Percentage'];
  uniqueProfileViewsCount: Scalars['Int'];
  conversationsCount: Scalars['Int'];
  responseRate?: Maybe<Scalars['Percentage']>;
  missions: PrivateStudentMissions;
  contactsRemainingCount: Scalars['Int'];
  unreadConversationsCount: Scalars['Int'];
  appointmentsCount: Scalars['Int'];
  wishedProfessionalsCount: Scalars['Int'];
  appointments: Array<Appointment>;
  assignments: Array<StudentParticipation>;
};


export type PrivateStudentProfileAvatarArgs = {
  version?: Maybe<PictureVersion>;
};


export type PrivateStudentProfileAppointmentsCountArgs = {
  scope?: Maybe<AppointmentListScope>;
};


export type PrivateStudentProfileAppointmentsArgs = {
  scope?: Maybe<AppointmentListScope>;
};


export type PrivateStudentProfileAssignmentsArgs = {
  scope?: Maybe<AssignmentsListScope>;
};

export enum ProfessionalProfileType {
  Mentor = 'MENTOR',
  Employee = 'EMPLOYEE',
  Vip = 'VIP'
}

export type PublicProfessionalProfile = PublicProfile & {
  __typename?: 'PublicProfessionalProfile';
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['AvatarUrl']>;
  phone?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  likeCount?: Maybe<Scalars['Int']>;
  jobTitle?: Maybe<Scalars['String']>;
  companyLogo?: Maybe<Scalars['LogoUrl']>;
  status: PublicProfessionalProfileStatus;
  unavailableUntil?: Maybe<Scalars['ISO8601DateTime']>;
  profileType: ProfessionalProfileType;
};


export type PublicProfessionalProfileAvatarArgs = {
  version?: Maybe<PictureVersion>;
};

export type PublicProfessionalProfileConnection = {
  __typename?: 'PublicProfessionalProfileConnection';
  edges: Array<PublicProfessionalProfileEdge>;
  nodes: Array<PublicProfessionalProfile>;
  pageInfo: PageInfo;
};

export type PublicProfessionalProfileEdge = {
  __typename?: 'PublicProfessionalProfileEdge';
  cursor: Scalars['String'];
  node?: Maybe<PublicProfessionalProfile>;
};

export enum PublicProfessionalProfileStatus {
  NeverPublished = 'NEVER_PUBLISHED',
  Published = 'PUBLISHED',
  RedCarpetOnly = 'RED_CARPET_ONLY',
  Hibernated = 'HIBERNATED',
  Unavailable = 'UNAVAILABLE',
  SoftDeleted = 'SOFT_DELETED',
  IcedUpOrRestricted = 'ICED_UP_OR_RESTRICTED',
  Unpublished = 'UNPUBLISHED',
  Anonymized = 'ANONYMIZED'
}

export type PublicProfile = {
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['AvatarUrl']>;
  phone?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
};


export type PublicProfileAvatarArgs = {
  version?: Maybe<PictureVersion>;
};

export type PublicStudentProfile = PublicProfile & {
  __typename?: 'PublicStudentProfile';
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['AvatarUrl']>;
  phone?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  confirmedAppointmentCount: Scalars['Int'];
  educations: Array<Education>;
  status: StudentStatus;
  email?: Maybe<Scalars['Email']>;
  description?: Maybe<Scalars['String']>;
  professionalProjects: Array<StudentProfessionalProject>;
};


export type PublicStudentProfileAvatarArgs = {
  version?: Maybe<PictureVersion>;
};

export type Query = {
  __typename?: 'Query';
  affiliatedAssignments: Array<StudentParticipation>;
  companies: Array<Company>;
  company?: Maybe<Company>;
  companyEmployee?: Maybe<CompanyEmployee>;
  companyEmployeeAppointment: CompanyEmployeeAppointment;
  companyEmployeeAppointments: CompanyEmployeeAppointmentConnection;
  companyReport: CompanyReport;
  companySectors: Array<CompanySector>;
  configuredAssignment: CoachAssignment;
  configuredAssignments: Array<CoachAssignment>;
  conversation?: Maybe<Conversation>;
  conversations?: Maybe<ConversationConnection>;
  localME: PrivateData;
  me: PrivateStudentProfile;
  mjgEmployees: Array<MjgEmployee>;
  partnerSchool: PartnerSchool;
  storedMessages: Array<StoredMessage>;
  wishlist: PublicProfessionalProfileConnection;
};


export type QueryCompaniesArgs = {
  asAdmin?: Maybe<Scalars['Boolean']>;
};


export type QueryCompanyArgs = {
  companyId: Scalars['ID'];
};


export type QueryCompanyEmployeeArgs = {
  employeeId: Scalars['ID'];
};


export type QueryCompanyEmployeeAppointmentArgs = {
  appointmentId: Scalars['ID'];
};


export type QueryCompanyEmployeeAppointmentsArgs = {
  companyId: Scalars['ID'];
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryCompanyReportArgs = {
  companyId: Scalars['ID'];
  range: CompanyReportRange;
};


export type QueryConfiguredAssignmentArgs = {
  assignmentId: Scalars['ID'];
};


export type QueryConversationArgs = {
  conversationId: Scalars['ID'];
};


export type QueryConversationsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryStoredMessagesArgs = {
  conversationId: Scalars['ID'];
};


export type QueryWishlistArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export enum RessourceOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SchoolCoach = PublicProfile & {
  __typename?: 'SchoolCoach';
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['AvatarUrl']>;
  phone?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  status: SchoolCoachStatus;
};


export type SchoolCoachAvatarArgs = {
  version?: Maybe<PictureVersion>;
};

export enum SchoolCoachStatus {
  Available = 'AVAILABLE',
  SoftDeleted = 'SOFT_DELETED',
  Anonymized = 'ANONYMIZED'
}

export type StoredMessage = {
  __typename?: 'StoredMessage';
  id: Scalars['ID'];
  text: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  status: MessageLocalStatus;
  sender?: Maybe<PrivateData>;
  fromMessageTemplateId?: Maybe<Scalars['String']>;
};

export type StudentAspiration = {
  __typename?: 'StudentAspiration';
  type: StudentProfessionalProjectType;
  duration: Scalars['String'];
  startsAtMonth: Scalars['Int'];
  startsAtYear: Scalars['Int'];
  postalCode: Scalars['Int'];
};

export type StudentAssignmentAppointment = {
  __typename?: 'StudentAssignmentAppointment';
  id: Scalars['ID'];
  conversation: Conversation;
  status: StudentAssignmentAppointmentStatus;
};

export enum StudentAssignmentAppointmentStatus {
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING',
  Invalidated = 'INVALIDATED'
}

export enum StudentMissions {
  AccountCreated = 'ACCOUNT_CREATED',
  ProfileComplete = 'PROFILE_COMPLETE',
  FirstMessageSent = 'FIRST_MESSAGE_SENT',
  FirstAppointmentOccurred = 'FIRST_APPOINTMENT_OCCURRED',
  FirstAppointmentReview = 'FIRST_APPOINTMENT_REVIEW',
  ThirdAppointmentOccurred = 'THIRD_APPOINTMENT_OCCURRED',
  FifthAppointmentOccurred = 'FIFTH_APPOINTMENT_OCCURRED',
  TenthAppointmentOccurred = 'TENTH_APPOINTMENT_OCCURRED',
  FifteenthAppointmentOccurred = 'FIFTEENTH_APPOINTMENT_OCCURRED',
  TwentiethAppointmentOccurred = 'TWENTIETH_APPOINTMENT_OCCURRED',
  ThirthiethAppointmentOccurred = 'THIRTHIETH_APPOINTMENT_OCCURRED',
  FiftiethAppointmentOccurred = 'FIFTIETH_APPOINTMENT_OCCURRED',
  SeventyFifthAppointmentOccurred = 'SEVENTY_FIFTH_APPOINTMENT_OCCURRED',
  HundredthAppointmentOccurred = 'HUNDREDTH_APPOINTMENT_OCCURRED'
}

export type StudentParticipation = {
  __typename?: 'StudentParticipation';
  id: Scalars['ID'];
  schoolName: Scalars['String'];
  startsAt: Scalars['ISO8601DateTime'];
  endsAt: Scalars['ISO8601DateTime'];
  description: Scalars['String'];
  coach?: Maybe<SchoolCoach>;
  appointmentsGoal: Scalars['Int'];
  confirmedAppointmentsCount: Scalars['Int'];
  appointments: Array<StudentAssignmentAppointment>;
};

export type StudentProfessionalProject = {
  __typename?: 'StudentProfessionalProject';
  id: Scalars['ID'];
  status: StudentProfessionalProjectStatus;
  type: StudentProfessionalProjectType;
  startsAtMonth: Scalars['Int'];
  startsAtYear: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
};

export enum StudentProfessionalProjectStatus {
  LookingFor = 'LOOKING_FOR',
  HaveFound = 'HAVE_FOUND',
  Ongoing = 'ONGOING',
  Past = 'PAST'
}

export enum StudentProfessionalProjectType {
  Internship = 'INTERNSHIP',
  Apprenticeship = 'APPRENTICESHIP',
  Vie = 'VIE',
  Via = 'VIA',
  Cdd = 'CDD',
  Cdi = 'CDI'
}

export enum StudentStatus {
  Available = 'AVAILABLE',
  SoftDeleted = 'SOFT_DELETED',
  Anonymized = 'ANONYMIZED'
}


export type Get_Affiliated_AssignmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Affiliated_AssignmentsQuery = (
  { __typename?: 'Query' }
  & { affiliatedAssignments: Array<(
    { __typename?: 'StudentParticipation' }
    & Pick<StudentParticipation, 'id' | 'schoolName' | 'startsAt' | 'endsAt' | 'description'>
  )> }
);

export type Affiliate_To_AssignmentMutationVariables = Exact<{
  assignmentID: Scalars['String'];
}>;


export type Affiliate_To_AssignmentMutation = (
  { __typename?: 'Mutation' }
  & { affiliateToAssignment: (
    { __typename?: 'AffiliationResult' }
    & Pick<AffiliationResult, 'earlyAffiliationWarning' | 'assignmentActivityStartsAt'>
  ) }
);

export type Get_CompanyQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type Get_CompanyQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name' | 'publishedEmployeesCount' | 'employeePackSize'>
    & { employees: Array<(
      { __typename?: 'CompanyEmployee' }
      & Pick<CompanyEmployee, 'id' | 'firstName' | 'lastName' | 'email' | 'jobTitle' | 'avatar' | 'companyAttribute1' | 'companyAttribute2' | 'companyAttribute3' | 'visibleInSearch' | 'status' | 'lastInvitationEmailSentAt' | 'canReceiveInvitationReminder' | 'canPublish' | 'canApprove' | 'canUnpublish' | 'canArchive'>
    )>, customAttributesSet: (
      { __typename?: 'CustomAttributesSet' }
      & Pick<CustomAttributesSet, 'customEmployeeAttribute1' | 'companyAttributeValues1' | 'customEmployeeAttribute2' | 'companyAttributeValues2' | 'customEmployeeAttribute3' | 'companyAttributeValues3'>
    ) }
  )> }
);

export type Get_Custom_Attributes_FieldsQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type Get_Custom_Attributes_FieldsQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id'>
    & { customAttributesSet: (
      { __typename?: 'CustomAttributesSet' }
      & Pick<CustomAttributesSet, 'customEmployeeAttribute1' | 'companyAttributeValues1' | 'customEmployeeAttribute2' | 'companyAttributeValues2' | 'customEmployeeAttribute3' | 'companyAttributeValues3'>
    ) }
  )> }
);

export type Add_EmployeeMutationVariables = Exact<{
  companyId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  companyAttribute1?: Maybe<Scalars['String']>;
  companyAttribute2?: Maybe<Scalars['String']>;
  companyAttribute3?: Maybe<Scalars['String']>;
}>;


export type Add_EmployeeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'inviteEmployee'>
);

export type Get_Company_Employee_PackQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type Get_Company_Employee_PackQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name' | 'publishedEmployeesCount' | 'employeePackSize'>
  )> }
);

export type Get_Company_Employee_StatisticsQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type Get_Company_Employee_StatisticsQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id'>
    & { employees: Array<(
      { __typename?: 'CompanyEmployee' }
      & Pick<CompanyEmployee, 'id' | 'status' | 'companyAttribute1' | 'companyAttribute2' | 'companyAttribute3'>
    )>, customAttributesSet: (
      { __typename?: 'CustomAttributesSet' }
      & Pick<CustomAttributesSet, 'customEmployeeAttribute1' | 'customEmployeeAttribute2' | 'customEmployeeAttribute3'>
    ) }
  )> }
);

export type Get_Company_Employee_TableQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type Get_Company_Employee_TableQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id'>
    & { employees: Array<(
      { __typename?: 'CompanyEmployee' }
      & Pick<CompanyEmployee, 'id' | 'firstName' | 'lastName' | 'email' | 'jobTitle' | 'avatar' | 'companyAttribute1' | 'companyAttribute2' | 'companyAttribute3' | 'visibleInSearch' | 'status' | 'lastInvitationEmailSentAt' | 'canReceiveInvitationReminder' | 'canPublish' | 'canApprove' | 'canUnpublish' | 'canArchive'>
    )>, customAttributesSet: (
      { __typename?: 'CustomAttributesSet' }
      & Pick<CustomAttributesSet, 'customEmployeeAttribute1' | 'customEmployeeAttribute2' | 'customEmployeeAttribute3'>
    ) }
  )> }
);

export type Get_Company_Archived_EmployeeQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type Get_Company_Archived_EmployeeQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id'>
    & { archivedEmployees: Array<(
      { __typename?: 'CompanyEmployee' }
      & Pick<CompanyEmployee, 'id' | 'firstName' | 'lastName' | 'email' | 'jobTitle' | 'avatar' | 'companyAttribute1' | 'companyAttribute2' | 'companyAttribute3' | 'visibleInSearch' | 'status' | 'lastInvitationEmailSentAt' | 'canReceiveInvitationReminder' | 'canPublish' | 'canApprove' | 'canUnpublish' | 'canArchive'>
    )> }
  )> }
);

export type Get_Company_Attributes_For_FiltersQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type Get_Company_Attributes_For_FiltersQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id'>
    & { customAttributesSet: (
      { __typename?: 'CustomAttributesSet' }
      & Pick<CustomAttributesSet, 'customEmployeeAttribute1' | 'companyAttributeValues1' | 'customEmployeeAttribute2' | 'companyAttributeValues2' | 'customEmployeeAttribute3' | 'companyAttributeValues3'>
    ) }
  )> }
);

export type Approve_EmployeeMutationVariables = Exact<{
  employeeId: Scalars['ID'];
}>;


export type Approve_EmployeeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'approveEmployee'>
);

export type Archive_EmployeeMutationVariables = Exact<{
  employeeId: Scalars['ID'];
}>;


export type Archive_EmployeeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'archiveEmployee'>
);

export type Publish_EmployeeMutationVariables = Exact<{
  employeeId: Scalars['ID'];
}>;


export type Publish_EmployeeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'publishEmployee'>
);

export type Resend_Employee_InvitationMutationVariables = Exact<{
  employeeId: Scalars['ID'];
}>;


export type Resend_Employee_InvitationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'sendEmployeeInvitationEmail'>
);

export type Unpublish_EmployeeMutationVariables = Exact<{
  employeeId: Scalars['ID'];
}>;


export type Unpublish_EmployeeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'unpublishEmployee'>
);

export type Get_Company_Pack_DetailsQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type Get_Company_Pack_DetailsQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'publishedEmployeesCount' | 'employeePackSize'>
  )> }
);

export type Get_Allowed_Employee_Actions_And_StatusQueryVariables = Exact<{
  employeeId: Scalars['ID'];
}>;


export type Get_Allowed_Employee_Actions_And_StatusQuery = (
  { __typename?: 'Query' }
  & { companyEmployee?: Maybe<(
    { __typename?: 'CompanyEmployee' }
    & Pick<CompanyEmployee, 'canPublish' | 'canApprove' | 'canUnpublish' | 'canArchive' | 'lastInvitationEmailSentAt' | 'visibleInSearch' | 'status'>
  )> }
);

export type Get_CompaniesQueryVariables = Exact<{
  asAdmin?: Maybe<Scalars['Boolean']>;
}>;


export type Get_CompaniesQuery = (
  { __typename?: 'Query' }
  & { companies: Array<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name'>
  )> }
);

export type Get_Company_Employee_AppointmentsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type Get_Company_Employee_AppointmentsQuery = (
  { __typename?: 'Query' }
  & { companyEmployeeAppointments: (
    { __typename?: 'CompanyEmployeeAppointmentConnection' }
    & Pick<CompanyEmployeeAppointmentConnection, 'total'>
    & { nodes: Array<(
      { __typename?: 'CompanyEmployeeAppointment' }
      & Pick<CompanyEmployeeAppointment, 'id' | 'from'>
      & { professional?: Maybe<(
        { __typename?: 'CompanyEmployee' }
        & Pick<CompanyEmployee, 'id' | 'firstName' | 'lastName' | 'email' | 'avatar' | 'status'>
      )>, student?: Maybe<(
        { __typename?: 'PublicStudentProfile' }
        & Pick<PublicStudentProfile, 'id' | 'firstName' | 'lastName' | 'avatar' | 'status' | 'email' | 'location' | 'phone'>
        & { educations: Array<(
          { __typename?: 'Education' }
          & Pick<Education, 'schoolName'>
        )> }
      )>, reviewFromProfessional?: Maybe<(
        { __typename?: 'AppointmentReviewFromProfessional' }
        & Pick<AppointmentReviewFromProfessional, 'appointmentStatus' | 'answer1' | 'answer2' | 'answer3' | 'messageForHr'>
      )>, reviewFromStudent?: Maybe<(
        { __typename?: 'AppointmentReviewFromStudent' }
        & Pick<AppointmentReviewFromStudent, 'appointmentStatus' | 'answer1' | 'answer2' | 'answer3' | 'wantToBeRecontacted'>
        & { aspiration?: Maybe<(
          { __typename?: 'StudentAspiration' }
          & Pick<StudentAspiration, 'type' | 'duration' | 'startsAtMonth' | 'startsAtYear' | 'postalCode'>
        )> }
      )> }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  ) }
);

export type Get_Company_Employee_AppointmentQueryVariables = Exact<{
  appointmentId: Scalars['ID'];
}>;


export type Get_Company_Employee_AppointmentQuery = (
  { __typename?: 'Query' }
  & { companyEmployeeAppointment: (
    { __typename?: 'CompanyEmployeeAppointment' }
    & Pick<CompanyEmployeeAppointment, 'id' | 'from'>
    & { professional?: Maybe<(
      { __typename?: 'CompanyEmployee' }
      & Pick<CompanyEmployee, 'id' | 'firstName' | 'lastName' | 'email' | 'avatar' | 'status' | 'jobTitle' | 'companyAttribute1' | 'companyAttribute2' | 'companyAttribute3'>
    )>, student?: Maybe<(
      { __typename?: 'PublicStudentProfile' }
      & Pick<PublicStudentProfile, 'id' | 'firstName' | 'lastName' | 'avatar' | 'status' | 'email' | 'location' | 'phone' | 'description'>
      & { educations: Array<(
        { __typename?: 'Education' }
        & Pick<Education, 'id' | 'startsAt' | 'endsAt' | 'diplomaType' | 'diplomaTitle' | 'schoolName'>
      )>, professionalProjects: Array<(
        { __typename?: 'StudentProfessionalProject' }
        & Pick<StudentProfessionalProject, 'id' | 'status' | 'type' | 'startsAtMonth' | 'startsAtYear' | 'description'>
      )> }
    )>, reviewFromProfessional?: Maybe<(
      { __typename?: 'AppointmentReviewFromProfessional' }
      & Pick<AppointmentReviewFromProfessional, 'appointmentStatus' | 'answer1' | 'answer2' | 'answer3' | 'messageForHr'>
    )>, reviewFromStudent?: Maybe<(
      { __typename?: 'AppointmentReviewFromStudent' }
      & Pick<AppointmentReviewFromStudent, 'appointmentStatus' | 'answer1' | 'answer2' | 'answer3' | 'wantToBeRecontacted'>
      & { aspiration?: Maybe<(
        { __typename?: 'StudentAspiration' }
        & Pick<StudentAspiration, 'type' | 'duration' | 'startsAtMonth' | 'startsAtYear' | 'postalCode'>
      )> }
    )> }
  ) }
);

export type Get_Company_Created_AtQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type Get_Company_Created_AtQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'createdAt' | 'name'>
  )> }
);

export type Get_Company_Employee_Appointments_TotalQueryVariables = Exact<{
  companyId: Scalars['ID'];
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}>;


export type Get_Company_Employee_Appointments_TotalQuery = (
  { __typename?: 'Query' }
  & { companyEmployeeAppointments: (
    { __typename?: 'CompanyEmployeeAppointmentConnection' }
    & Pick<CompanyEmployeeAppointmentConnection, 'total'>
  ) }
);

export type Get_Company_For_ConfigurationQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type Get_Company_For_ConfigurationQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name' | 'description' | 'companySize' | 'companySector' | 'companyLogo'>
    & { customAttributesSet: (
      { __typename?: 'CustomAttributesSet' }
      & Pick<CustomAttributesSet, 'customEmployeeAttribute1' | 'companyAttributeValues1' | 'customEmployeeAttribute2' | 'companyAttributeValues2' | 'customEmployeeAttribute3' | 'companyAttributeValues3'>
    ) }
  )>, companySectors: Array<(
    { __typename?: 'CompanySector' }
    & Pick<CompanySector, 'id' | 'name'>
  )> }
);

export type Get_Company_Custom_AttributesQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type Get_Company_Custom_AttributesQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id'>
    & { customAttributesSet: (
      { __typename?: 'CustomAttributesSet' }
      & Pick<CustomAttributesSet, 'customEmployeeAttribute1' | 'companyAttributeValues1' | 'customEmployeeAttribute2' | 'companyAttributeValues2' | 'customEmployeeAttribute3' | 'companyAttributeValues3'>
    ) }
  )> }
);

export type Update_Company_Custom_AttributesMutationVariables = Exact<{
  companyId: Scalars['ID'];
  number: Scalars['Int'];
  customEmployeeAttribute: Scalars['String'];
  companyAttributeValues: Array<Scalars['String']> | Scalars['String'];
}>;


export type Update_Company_Custom_AttributesMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateCustomAttribute'>
);

export type Get_Company_General_InformationsQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type Get_Company_General_InformationsQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name' | 'companySize' | 'companySector' | 'companyLogo'>
  )> }
);

export type Get_Company_SectorsQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Company_SectorsQuery = (
  { __typename?: 'Query' }
  & { companySectors: Array<(
    { __typename?: 'CompanySector' }
    & Pick<CompanySector, 'id' | 'name'>
  )> }
);

export type Update_Company_General_InformationsMutationVariables = Exact<{
  companyId: Scalars['ID'];
  sectorId?: Maybe<Scalars['ID']>;
  size?: Maybe<CompanySize>;
}>;


export type Update_Company_General_InformationsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateCompany'>
);

export type Get_Company_PresentationQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type Get_Company_PresentationQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'description'>
  )> }
);

export type Update_Company_DescriptionMutationVariables = Exact<{
  companyId: Scalars['ID'];
  description: Scalars['String'];
}>;


export type Update_Company_DescriptionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateCompany'>
);

export type Get_Global_Company_ReportQueryVariables = Exact<{
  range: CompanyReportRange;
  companyId: Scalars['ID'];
}>;


export type Get_Global_Company_ReportQuery = (
  { __typename?: 'Query' }
  & { companyReport: (
    { __typename?: 'CompanyReport' }
    & Pick<CompanyReport, 'companyId' | 'from' | 'to' | 'lastUpdatedAt' | 'newConversationCount' | 'contactedEmployeesCount' | 'responseRate' | 'appointmentCount' | 'publishedEmployeeCount' | 'publishedEmployeesWithAppointmentRate' | 'employeesViewCount' | 'uniqueProfileViewsFromStudents' | 'studentsSeeingThemselvesInTheSectorRate' | 'wishCount' | 'likeCount'>
    & { bestProfiles: Array<(
      { __typename?: 'CompanyReportTopEmployees' }
      & Pick<CompanyReportTopEmployees, 'id' | 'avatar' | 'firstName' | 'lastName' | 'jobTitle' | 'appointmentCount' | 'medal'>
    )> }
  ) }
);

export type Get_Company_Activity_ReportQueryVariables = Exact<{
  range: CompanyReportRange;
  companyId: Scalars['ID'];
}>;


export type Get_Company_Activity_ReportQuery = (
  { __typename?: 'Query' }
  & { companyReport: (
    { __typename?: 'CompanyReport' }
    & Pick<CompanyReport, 'companyId' | 'newConversationCount' | 'contactedEmployeesCount' | 'responseRate' | 'appointmentCount' | 'publishedEmployeeCount' | 'publishedEmployeesWithAppointmentRate'>
  ) }
);

export type Get_Company_Attractiveness_ReportQueryVariables = Exact<{
  range: CompanyReportRange;
  companyId: Scalars['ID'];
}>;


export type Get_Company_Attractiveness_ReportQuery = (
  { __typename?: 'Query' }
  & { companyReport: (
    { __typename?: 'CompanyReport' }
    & Pick<CompanyReport, 'companyId' | 'employeesViewCount' | 'uniqueProfileViewsFromStudents' | 'wishCount' | 'likeCount' | 'studentsSeeingThemselvesInTheSectorRate'>
  ) }
);

export type Get_Last_Generated_DatetimeQueryVariables = Exact<{
  range: CompanyReportRange;
  companyId: Scalars['ID'];
}>;


export type Get_Last_Generated_DatetimeQuery = (
  { __typename?: 'Query' }
  & { companyReport: (
    { __typename?: 'CompanyReport' }
    & Pick<CompanyReport, 'companyId' | 'lastUpdatedAt'>
  ) }
);

export type Get_Company_Report_Date_RangeQueryVariables = Exact<{
  range: CompanyReportRange;
  companyId: Scalars['ID'];
}>;


export type Get_Company_Report_Date_RangeQuery = (
  { __typename?: 'Query' }
  & { companyReport: (
    { __typename?: 'CompanyReport' }
    & Pick<CompanyReport, 'companyId' | 'from' | 'to'>
  ) }
);

export type Get_Company_Information_For_DashboardQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type Get_Company_Information_For_DashboardQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name' | 'companyLogo' | 'publishedEmployeesCount' | 'employeePackSize' | 'activeProfilePercentage' | 'lastReportGeneratedAt'>
  )> }
);

export type Get_Last_Report_DataQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type Get_Last_Report_DataQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name' | 'lastReportGeneratedAt'>
  )> }
);

export type Get_Company_Report_Top_EmployeesQueryVariables = Exact<{
  companyId: Scalars['ID'];
  range: CompanyReportRange;
}>;


export type Get_Company_Report_Top_EmployeesQuery = (
  { __typename?: 'Query' }
  & { companyReport: (
    { __typename?: 'CompanyReport' }
    & { bestProfiles: Array<(
      { __typename?: 'CompanyReportTopEmployees' }
      & Pick<CompanyReportTopEmployees, 'id' | 'avatar' | 'firstName' | 'lastName' | 'jobTitle' | 'appointmentCount' | 'medal'>
    )> }
  ) }
);

export type Get_Companies_ListQueryVariables = Exact<{
  asAdmin?: Maybe<Scalars['Boolean']>;
}>;


export type Get_Companies_ListQuery = (
  { __typename?: 'Query' }
  & { companies: Array<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name'>
  )> }
);

export type Get_Conversation_Created_AtQueryVariables = Exact<{
  conversationId: Scalars['ID'];
}>;


export type Get_Conversation_Created_AtQuery = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<(
    { __typename?: 'Conversation' }
    & Pick<Conversation, 'id' | 'createdAt'>
  )> }
);

export type Get_Conversations_ListQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
}>;


export type Get_Conversations_ListQuery = (
  { __typename?: 'Query' }
  & { conversations?: Maybe<(
    { __typename?: 'ConversationConnection' }
    & { nodes: Array<(
      { __typename?: 'Conversation' }
      & Pick<Conversation, 'id'>
      & { lastMessage?: Maybe<(
        { __typename?: 'Message' }
        & Pick<Message, 'createdAt' | 'text' | 'seenAt'>
        & { sender?: Maybe<(
          { __typename?: 'SchoolCoach' }
          & Pick<SchoolCoach, 'id'>
        ) | (
          { __typename?: 'PublicProfessionalProfile' }
          & Pick<PublicProfessionalProfile, 'id'>
        ) | (
          { __typename?: 'PublicStudentProfile' }
          & Pick<PublicStudentProfile, 'id'>
        )> }
      )>, professional?: Maybe<(
        { __typename?: 'PublicProfessionalProfile' }
        & Pick<PublicProfessionalProfile, 'id' | 'firstName' | 'avatar' | 'companyName' | 'status'>
      )>, student?: Maybe<(
        { __typename?: 'PublicStudentProfile' }
        & Pick<PublicStudentProfile, 'id' | 'firstName' | 'avatar' | 'status'>
        & { educations: Array<(
          { __typename?: 'Education' }
          & Pick<Education, 'schoolName' | 'endsAt'>
        )> }
      )>, appointmentClaims: Array<(
        { __typename?: 'AppointmentClaim' }
        & Pick<AppointmentClaim, 'resolvedAt'>
      )> }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'startCursor' | 'hasPreviousPage'>
    ) }
  )> }
);

export type Get_ConversationQueryVariables = Exact<{
  conversationId: Scalars['ID'];
}>;


export type Get_ConversationQuery = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<(
    { __typename?: 'Conversation' }
    & Pick<Conversation, 'id' | 'createdAt'>
    & { lastMessage?: Maybe<(
      { __typename?: 'Message' }
      & Pick<Message, 'seenAt'>
      & { sender?: Maybe<(
        { __typename?: 'SchoolCoach' }
        & Pick<SchoolCoach, 'id'>
      ) | (
        { __typename?: 'PublicProfessionalProfile' }
        & Pick<PublicProfessionalProfile, 'id'>
      ) | (
        { __typename?: 'PublicStudentProfile' }
        & Pick<PublicStudentProfile, 'id'>
      )> }
    )>, professional?: Maybe<(
      { __typename?: 'PublicProfessionalProfile' }
      & Pick<PublicProfessionalProfile, 'id' | 'firstName' | 'lastName' | 'jobTitle' | 'companyName' | 'avatar' | 'phone' | 'location' | 'status'>
    )>, student?: Maybe<(
      { __typename?: 'PublicStudentProfile' }
      & Pick<PublicStudentProfile, 'id' | 'firstName' | 'lastName' | 'avatar' | 'phone' | 'location' | 'status' | 'confirmedAppointmentCount'>
    )>, messages: Array<(
      { __typename?: 'Message' }
      & Pick<Message, 'id' | 'text' | 'createdAt' | 'status'>
      & { sender?: Maybe<(
        { __typename?: 'SchoolCoach' }
        & Pick<SchoolCoach, 'id' | 'firstName' | 'lastName' | 'avatar'>
      ) | (
        { __typename?: 'PublicProfessionalProfile' }
        & Pick<PublicProfessionalProfile, 'id' | 'firstName' | 'lastName' | 'avatar'>
        & { professionalStatus: PublicProfessionalProfile['status'] }
      ) | (
        { __typename?: 'PublicStudentProfile' }
        & Pick<PublicStudentProfile, 'id' | 'firstName' | 'lastName' | 'avatar'>
        & { studentStatus: PublicStudentProfile['status'] }
      )>, attachment?: Maybe<(
        { __typename?: 'MessageAttachment' }
        & Pick<MessageAttachment, 'name' | 'url' | 'scannedByAntivirus'>
      )> }
    )> }
  )> }
);

export type Get_Conversation_Interlocutor_InformationsQueryVariables = Exact<{
  conversationId: Scalars['ID'];
}>;


export type Get_Conversation_Interlocutor_InformationsQuery = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<(
    { __typename?: 'Conversation' }
    & Pick<Conversation, 'id'>
    & { professional?: Maybe<(
      { __typename?: 'PublicProfessionalProfile' }
      & Pick<PublicProfessionalProfile, 'id' | 'firstName' | 'lastName' | 'jobTitle' | 'companyName' | 'avatar' | 'phone' | 'location' | 'status'>
    )>, student?: Maybe<(
      { __typename?: 'PublicStudentProfile' }
      & Pick<PublicStudentProfile, 'id' | 'firstName' | 'lastName' | 'avatar' | 'phone' | 'location' | 'status' | 'confirmedAppointmentCount'>
    )> }
  )> }
);

export type Get_Conversation_MessagesQueryVariables = Exact<{
  conversationId: Scalars['ID'];
}>;


export type Get_Conversation_MessagesQuery = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<(
    { __typename?: 'Conversation' }
    & Pick<Conversation, 'id'>
    & { messages: Array<(
      { __typename?: 'Message' }
      & Pick<Message, 'id' | 'text' | 'createdAt' | 'status'>
      & { sender?: Maybe<(
        { __typename?: 'SchoolCoach' }
        & Pick<SchoolCoach, 'id' | 'firstName' | 'lastName' | 'avatar'>
      ) | (
        { __typename?: 'PublicProfessionalProfile' }
        & Pick<PublicProfessionalProfile, 'id' | 'firstName' | 'lastName' | 'avatar'>
        & { professionalStatus: PublicProfessionalProfile['status'] }
      ) | (
        { __typename?: 'PublicStudentProfile' }
        & Pick<PublicStudentProfile, 'id' | 'firstName' | 'lastName' | 'avatar'>
        & { studentStatus: PublicStudentProfile['status'] }
      )>, attachment?: Maybe<(
        { __typename?: 'MessageAttachment' }
        & Pick<MessageAttachment, 'name' | 'url' | 'scannedByAntivirus'>
      )> }
    )> }
  )> }
);

export type Get_Conversation_Stored_MessagesQueryVariables = Exact<{
  conversationId: Scalars['ID'];
}>;


export type Get_Conversation_Stored_MessagesQuery = (
  { __typename?: 'Query' }
  & { storedMessages: Array<(
    { __typename?: 'StoredMessage' }
    & Pick<StoredMessage, 'id' | 'text' | 'createdAt' | 'status' | 'fromMessageTemplateId'>
    & { sender?: Maybe<(
      { __typename?: 'PrivateData' }
      & Pick<PrivateData, 'id' | 'avatar'>
    )> }
  )> }
);

export type Retry_Send_MessageMutationVariables = Exact<{
  conversationId: Scalars['ID'];
  text: Scalars['String'];
  fromMessageTemplateId?: Maybe<Scalars['ID']>;
  attachment?: Maybe<Scalars['Upload']>;
}>;


export type Retry_Send_MessageMutation = (
  { __typename?: 'Mutation' }
  & { sendMessage?: Maybe<(
    { __typename?: 'Message' }
    & Pick<Message, 'id'>
  )> }
);

export type Get_Conversation_Interlocutor_Informations_For_MobileQueryVariables = Exact<{
  conversationId: Scalars['ID'];
}>;


export type Get_Conversation_Interlocutor_Informations_For_MobileQuery = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<(
    { __typename?: 'Conversation' }
    & Pick<Conversation, 'id'>
    & { professional?: Maybe<(
      { __typename?: 'PublicProfessionalProfile' }
      & Pick<PublicProfessionalProfile, 'id' | 'firstName' | 'avatar' | 'status'>
    )>, student?: Maybe<(
      { __typename?: 'PublicStudentProfile' }
      & Pick<PublicStudentProfile, 'id' | 'firstName' | 'avatar' | 'status'>
    )> }
  )> }
);

export type Get_Conversation_Messages_And_InterlocutorsQueryVariables = Exact<{
  conversationId: Scalars['ID'];
}>;


export type Get_Conversation_Messages_And_InterlocutorsQuery = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<(
    { __typename?: 'Conversation' }
    & Pick<Conversation, 'id'>
    & { professional?: Maybe<(
      { __typename?: 'PublicProfessionalProfile' }
      & Pick<PublicProfessionalProfile, 'id'>
    )>, student?: Maybe<(
      { __typename?: 'PublicStudentProfile' }
      & Pick<PublicStudentProfile, 'id'>
    )>, messages: Array<(
      { __typename?: 'Message' }
      & Pick<Message, 'id' | 'text' | 'createdAt'>
      & { sender?: Maybe<(
        { __typename?: 'SchoolCoach' }
        & Pick<SchoolCoach, 'id' | 'firstName' | 'lastName' | 'avatar'>
      ) | (
        { __typename?: 'PublicProfessionalProfile' }
        & Pick<PublicProfessionalProfile, 'id' | 'firstName' | 'lastName' | 'avatar'>
      ) | (
        { __typename?: 'PublicStudentProfile' }
        & Pick<PublicStudentProfile, 'id' | 'firstName' | 'lastName' | 'avatar'>
      )> }
    )> }
  )> }
);

export type Get_Conversation_InterlocutorsQueryVariables = Exact<{
  conversationId: Scalars['ID'];
}>;


export type Get_Conversation_InterlocutorsQuery = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<(
    { __typename?: 'Conversation' }
    & Pick<Conversation, 'id'>
    & { professional?: Maybe<(
      { __typename?: 'PublicProfessionalProfile' }
      & Pick<PublicProfessionalProfile, 'id' | 'firstName' | 'lastName' | 'jobTitle' | 'companyName' | 'avatar' | 'phone' | 'location' | 'status'>
    )>, student?: Maybe<(
      { __typename?: 'PublicStudentProfile' }
      & Pick<PublicStudentProfile, 'id' | 'firstName' | 'lastName' | 'avatar' | 'phone' | 'location' | 'status' | 'confirmedAppointmentCount'>
    )> }
  )> }
);

export type Get_Conversation_Messages_For_CountQueryVariables = Exact<{
  conversationId: Scalars['ID'];
}>;


export type Get_Conversation_Messages_For_CountQuery = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<(
    { __typename?: 'Conversation' }
    & Pick<Conversation, 'id'>
    & { professional?: Maybe<(
      { __typename?: 'PublicProfessionalProfile' }
      & Pick<PublicProfessionalProfile, 'id'>
    )>, student?: Maybe<(
      { __typename?: 'PublicStudentProfile' }
      & Pick<PublicStudentProfile, 'id'>
    )>, messages: Array<(
      { __typename?: 'Message' }
      & Pick<Message, 'id'>
      & { sender?: Maybe<(
        { __typename?: 'SchoolCoach' }
        & Pick<SchoolCoach, 'id'>
      ) | (
        { __typename?: 'PublicProfessionalProfile' }
        & Pick<PublicProfessionalProfile, 'id'>
      ) | (
        { __typename?: 'PublicStudentProfile' }
        & Pick<PublicStudentProfile, 'id'>
      )> }
    )> }
  )> }
);

export type Get_Last_Conversation_MessageQueryVariables = Exact<{
  conversationId: Scalars['ID'];
}>;


export type Get_Last_Conversation_MessageQuery = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<(
    { __typename?: 'Conversation' }
    & { lastMessage?: Maybe<(
      { __typename?: 'Message' }
      & { sender?: Maybe<(
        { __typename?: 'SchoolCoach' }
        & Pick<SchoolCoach, 'id'>
      ) | (
        { __typename?: 'PublicProfessionalProfile' }
        & Pick<PublicProfessionalProfile, 'id'>
      ) | (
        { __typename?: 'PublicStudentProfile' }
        & Pick<PublicStudentProfile, 'id'>
      )> }
    )> }
  )> }
);

export type Send_MessageMutationVariables = Exact<{
  conversationId: Scalars['ID'];
  text: Scalars['String'];
  fromMessageTemplateId?: Maybe<Scalars['ID']>;
  attachment?: Maybe<Scalars['Upload']>;
}>;


export type Send_MessageMutation = (
  { __typename?: 'Mutation' }
  & { sendMessage?: Maybe<(
    { __typename?: 'Message' }
    & Pick<Message, 'id' | 'text' | 'createdAt'>
    & { sender?: Maybe<(
      { __typename?: 'SchoolCoach' }
      & Pick<SchoolCoach, 'id' | 'avatar' | 'firstName' | 'lastName'>
    ) | (
      { __typename?: 'PublicProfessionalProfile' }
      & Pick<PublicProfessionalProfile, 'id' | 'avatar' | 'firstName' | 'lastName'>
      & { professionalStatus: PublicProfessionalProfile['status'] }
    ) | (
      { __typename?: 'PublicStudentProfile' }
      & Pick<PublicStudentProfile, 'id' | 'avatar' | 'firstName' | 'lastName'>
      & { studentStatus: PublicStudentProfile['status'] }
    )>, attachment?: Maybe<(
      { __typename?: 'MessageAttachment' }
      & Pick<MessageAttachment, 'name' | 'url' | 'scannedByAntivirus'>
    )> }
  )> }
);

export type Get_Private_DataQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Private_DataQuery = (
  { __typename?: 'Query' }
  & { localME: (
    { __typename?: 'PrivateData' }
    & Pick<PrivateData, 'unreadMessageCount'>
  ) }
);

export type Get_Unreadmessages_For_Mobile_NotificationQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Unreadmessages_For_Mobile_NotificationQuery = (
  { __typename?: 'Query' }
  & { localME: (
    { __typename?: 'PrivateData' }
    & Pick<PrivateData, 'unreadMessageCount'>
  ) }
);

export type Configure_FdrMutationVariables = Exact<{
  schoolName: Scalars['String'];
  diplomaLevel: Array<DiplomaLevel> | DiplomaLevel;
  campusName: Scalars['String'];
  customIdentifier?: Maybe<Scalars['String']>;
  supervisorEmail?: Maybe<Scalars['String']>;
  startsAt: Scalars['ISO8601DateTime'];
  endsAt: Scalars['ISO8601DateTime'];
  academicYear: Scalars['String'];
  numberOfMandatoryAppointmentsPerStudent: Scalars['Int'];
  appointmentBonusThreshold1?: Maybe<Scalars['Int']>;
  appointmentBonusThreshold2?: Maybe<Scalars['Int']>;
  emailReminderActivated: Scalars['Boolean'];
  emailReminderWeeklyRate?: Maybe<Scalars['Int']>;
  emailReminderLanguage?: Maybe<CommunicationLanguage>;
  conversationBonusActivated: Scalars['Boolean'];
  conversationBonusMessageCount?: Maybe<Scalars['Int']>;
  conversationBonusDeadline?: Maybe<Scalars['Int']>;
  conversationPenaltyActivated: Scalars['Boolean'];
  description: Scalars['String'];
}>;


export type Configure_FdrMutation = (
  { __typename?: 'Mutation' }
  & { createContractualFdr: (
    { __typename?: 'FDRConfigurationSuccess' }
    & Pick<FdrConfigurationSuccess, 'fdrCoachLink'>
  ) }
);

export type Update_Contractual_AssignmentMutationVariables = Exact<{
  assignmentId: Scalars['ID'];
  name: Scalars['String'];
  size: Scalars['Int'];
}>;


export type Update_Contractual_AssignmentMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateContractualAssignment'>
);

export type Get_Configured_AssignmentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type Get_Configured_AssignmentQuery = (
  { __typename?: 'Query' }
  & { configuredAssignment: (
    { __typename?: 'CoachAssignment' }
    & Pick<CoachAssignment, 'id' | 'size' | 'name'>
  ) }
);

export type Get_Configured_Assignment_InformationsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type Get_Configured_Assignment_InformationsQuery = (
  { __typename?: 'Query' }
  & { configuredAssignment: (
    { __typename?: 'CoachAssignment' }
    & Pick<CoachAssignment, 'id' | 'schoolName' | 'campusName' | 'diplomaLevel' | 'startsAt' | 'endsAt' | 'size'>
  ) }
);

export type Get_Assignment_ProgressQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type Get_Assignment_ProgressQuery = (
  { __typename?: 'Query' }
  & { configuredAssignment: (
    { __typename?: 'CoachAssignment' }
    & Pick<CoachAssignment, 'size' | 'affiliatedStudentCount' | 'studentWithConversationCount' | 'studentWithAppointmentWithFeedbackCount'>
  ) }
);

export type Get_Configured_Assignment_List_To_SelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Configured_Assignment_List_To_SelectorQuery = (
  { __typename?: 'Query' }
  & { configuredAssignments: Array<(
    { __typename?: 'CoachAssignment' }
    & Pick<CoachAssignment, 'id' | 'name'>
  )> }
);

export type Get_Assignment_Student_ListQueryVariables = Exact<{
  assignmentId: Scalars['ID'];
}>;


export type Get_Assignment_Student_ListQuery = (
  { __typename?: 'Query' }
  & { configuredAssignment: (
    { __typename?: 'CoachAssignment' }
    & Pick<CoachAssignment, 'dataRecalculatedAt'>
    & { participants: Array<(
      { __typename?: 'AssignmentParticipant' }
      & Pick<AssignmentParticipant, 'id' | 'firstName' | 'lastName' | 'avatar' | 'affiliatedAt' | 'firstConversationAt' | 'conversationCount' | 'conversationWithoutReplyFromStudentCount' | 'firstAppointmentAt' | 'appointmentWithFeedbackCount' | 'pendingAppointmentCount' | 'status'>
    )> }
  ) }
);

export type Desaffiliate_StudentMutationVariables = Exact<{
  assignmentId: Scalars['ID'];
  participationId: Scalars['ID'];
}>;


export type Desaffiliate_StudentMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'desafilliateStudentFromAssignment'>
);

export type Get_Configured_Assignments_List_To_CountQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Configured_Assignments_List_To_CountQuery = (
  { __typename?: 'Query' }
  & { configuredAssignments: Array<(
    { __typename?: 'CoachAssignment' }
    & Pick<CoachAssignment, 'id'>
  )> }
);

export type Get_Configured_AssignmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Configured_AssignmentsQuery = (
  { __typename?: 'Query' }
  & { configuredAssignments: Array<(
    { __typename?: 'CoachAssignment' }
    & Pick<CoachAssignment, 'id' | 'name'>
  )> }
);

export type Get_Configured_Assignment_ViewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type Get_Configured_Assignment_ViewQuery = (
  { __typename?: 'Query' }
  & { configuredAssignment: (
    { __typename?: 'CoachAssignment' }
    & Pick<CoachAssignment, 'id' | 'schoolName' | 'campusName' | 'diplomaLevel' | 'startsAt' | 'endsAt' | 'name' | 'size' | 'dataRecalculatedAt' | 'affiliatedStudentCount' | 'studentWithConversationCount' | 'studentWithAppointmentWithFeedbackCount'>
    & { participants: Array<(
      { __typename?: 'AssignmentParticipant' }
      & Pick<AssignmentParticipant, 'id' | 'firstName' | 'lastName' | 'avatar' | 'affiliatedAt' | 'firstConversationAt' | 'conversationCount' | 'conversationWithoutReplyFromStudentCount' | 'firstAppointmentAt' | 'appointmentWithFeedbackCount' | 'pendingAppointmentCount'>
    )> }
  ) }
);

export type Get_Partner_SchoolQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Partner_SchoolQuery = (
  { __typename?: 'Query' }
  & { partnerSchool: (
    { __typename?: 'PartnerSchool' }
    & Pick<PartnerSchool, 'id' | 'name'>
    & { configurableFdrs: Array<(
      { __typename?: 'FDR' }
      & Pick<Fdr, 'id' | 'operationName'>
    )> }
  ) }
);

export type Configure_ExerciseMutationVariables = Exact<{
  fdrId: Scalars['ID'];
  name: Scalars['String'];
  size: Scalars['Int'];
  emailLanguage: CommunicationLanguage;
}>;


export type Configure_ExerciseMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'configureContractualAssignment'>
);

export type Get_Student_WishlistQueryVariables = Exact<{
  after?: Maybe<Scalars['String']>;
}>;


export type Get_Student_WishlistQuery = (
  { __typename?: 'Query' }
  & { wishlist: (
    { __typename?: 'PublicProfessionalProfileConnection' }
    & { nodes: Array<(
      { __typename?: 'PublicProfessionalProfile' }
      & Pick<PublicProfessionalProfile, 'id' | 'firstName' | 'avatar' | 'companyName' | 'jobTitle' | 'companyLogo' | 'status' | 'profileType' | 'likeCount' | 'unavailableUntil'>
      & { background: PublicProfessionalProfile['avatar'] }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type Get_Student_Dashboard_ViewQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Student_Dashboard_ViewQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'PrivateStudentProfile' }
    & Pick<PrivateStudentProfile, 'signupAt' | 'lastUpdatedAt' | 'profileCompletionStatus' | 'uniqueProfileViewsCount' | 'conversationsCount' | 'responseRate' | 'contactsRemainingCount' | 'unreadConversationsCount' | 'wishedProfessionalsCount' | 'id' | 'avatar' | 'firstName'>
    & { pastReviewedAppointmentsCount: PrivateStudentProfile['appointmentsCount'], upcomingAppointmentsCount: PrivateStudentProfile['appointmentsCount'] }
    & { missions: (
      { __typename?: 'PrivateStudentMissions' }
      & Pick<PrivateStudentMissions, 'previous' | 'current' | 'next'>
    ), nextAppointment: Array<(
      { __typename?: 'Appointment' }
      & Pick<Appointment, 'id' | 'from'>
      & { conversation?: Maybe<(
        { __typename?: 'Conversation' }
        & Pick<Conversation, 'id'>
        & { professional?: Maybe<(
          { __typename?: 'PublicProfessionalProfile' }
          & Pick<PublicProfessionalProfile, 'id' | 'avatar' | 'firstName'>
        )> }
      )> }
    )>, assignments: Array<(
      { __typename?: 'StudentParticipation' }
      & Pick<StudentParticipation, 'id' | 'schoolName' | 'startsAt' | 'endsAt' | 'appointmentsGoal' | 'confirmedAppointmentsCount'>
      & { coach?: Maybe<(
        { __typename?: 'SchoolCoach' }
        & Pick<SchoolCoach, 'id' | 'firstName' | 'lastName' | 'status'>
      )>, appointments: Array<(
        { __typename?: 'StudentAssignmentAppointment' }
        & Pick<StudentAssignmentAppointment, 'id' | 'status'>
        & { conversation: (
          { __typename?: 'Conversation' }
          & Pick<Conversation, 'id'>
          & { professional?: Maybe<(
            { __typename?: 'PublicProfessionalProfile' }
            & Pick<PublicProfessionalProfile, 'id' | 'firstName' | 'avatar' | 'status'>
          )> }
        ) }
      )> }
    )> }
  ) }
);

export type Get_Student_Dashboard_Current_ActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Student_Dashboard_Current_ActivitiesQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'PrivateStudentProfile' }
    & Pick<PrivateStudentProfile, 'contactsRemainingCount' | 'unreadConversationsCount' | 'wishedProfessionalsCount' | 'id'>
    & { upcomingAppointmentsCount: PrivateStudentProfile['appointmentsCount'] }
  ) }
);

export type Get_Student_Dashboard_Upcoming_AppointmentQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Student_Dashboard_Upcoming_AppointmentQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'PrivateStudentProfile' }
    & Pick<PrivateStudentProfile, 'id'>
    & { nextAppointment: Array<(
      { __typename?: 'Appointment' }
      & Pick<Appointment, 'id' | 'from'>
      & { conversation?: Maybe<(
        { __typename?: 'Conversation' }
        & Pick<Conversation, 'id'>
        & { professional?: Maybe<(
          { __typename?: 'PublicProfessionalProfile' }
          & Pick<PublicProfessionalProfile, 'id' | 'avatar' | 'firstName'>
        )> }
      )> }
    )> }
  ) }
);

export type Get_Student_Dashboard_Current_Exercice_ExistQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Student_Dashboard_Current_Exercice_ExistQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'PrivateStudentProfile' }
    & Pick<PrivateStudentProfile, 'id'>
    & { assignments: Array<(
      { __typename?: 'StudentParticipation' }
      & Pick<StudentParticipation, 'id'>
    )> }
  ) }
);

export type Get_Student_Dashboard_Current_Exercice_General_InformationsQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Student_Dashboard_Current_Exercice_General_InformationsQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'PrivateStudentProfile' }
    & Pick<PrivateStudentProfile, 'id'>
    & { assignments: Array<(
      { __typename?: 'StudentParticipation' }
      & Pick<StudentParticipation, 'id' | 'schoolName' | 'startsAt' | 'endsAt' | 'appointmentsGoal' | 'confirmedAppointmentsCount'>
      & { coach?: Maybe<(
        { __typename?: 'SchoolCoach' }
        & Pick<SchoolCoach, 'id' | 'firstName' | 'lastName' | 'status'>
      )>, appointments: Array<(
        { __typename?: 'StudentAssignmentAppointment' }
        & Pick<StudentAssignmentAppointment, 'id'>
      )> }
    )> }
  ) }
);

export type Get_Student_Dashboard_Exercice_Appointments_ListQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Student_Dashboard_Exercice_Appointments_ListQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'PrivateStudentProfile' }
    & Pick<PrivateStudentProfile, 'id'>
    & { assignments: Array<(
      { __typename?: 'StudentParticipation' }
      & { appointments: Array<(
        { __typename?: 'StudentAssignmentAppointment' }
        & Pick<StudentAssignmentAppointment, 'id' | 'status'>
        & { conversation: (
          { __typename?: 'Conversation' }
          & Pick<Conversation, 'id'>
          & { professional?: Maybe<(
            { __typename?: 'PublicProfessionalProfile' }
            & Pick<PublicProfessionalProfile, 'id' | 'firstName' | 'avatar' | 'status'>
          )> }
        ) }
      )> }
    )> }
  ) }
);

export type Get_Student_Dashboard_Previous_Mission_For_AdvicesQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Student_Dashboard_Previous_Mission_For_AdvicesQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'PrivateStudentProfile' }
    & Pick<PrivateStudentProfile, 'id'>
    & { missions: (
      { __typename?: 'PrivateStudentMissions' }
      & Pick<PrivateStudentMissions, 'current'>
    ) }
  ) }
);

export type Get_Student_Dashboard_Current_Mission_For_RessourceQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Student_Dashboard_Current_Mission_For_RessourceQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'PrivateStudentProfile' }
    & Pick<PrivateStudentProfile, 'id'>
    & { missions: (
      { __typename?: 'PrivateStudentMissions' }
      & Pick<PrivateStudentMissions, 'current'>
    ) }
  ) }
);

export type Get_Student_Dashboard_Missions_For_TimelineQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Student_Dashboard_Missions_For_TimelineQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'PrivateStudentProfile' }
    & Pick<PrivateStudentProfile, 'id'>
    & { missions: (
      { __typename?: 'PrivateStudentMissions' }
      & Pick<PrivateStudentMissions, 'current' | 'next'>
    ) }
  ) }
);

export type Get_Student_Dashboard_Global_StatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Student_Dashboard_Global_StatisticsQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'PrivateStudentProfile' }
    & Pick<PrivateStudentProfile, 'uniqueProfileViewsCount' | 'conversationsCount' | 'responseRate' | 'id'>
    & { pastReviewedAppointmentsCount: PrivateStudentProfile['appointmentsCount'] }
  ) }
);

export type Get_Student_Dashboard_Profile_InformationsQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Student_Dashboard_Profile_InformationsQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'PrivateStudentProfile' }
    & Pick<PrivateStudentProfile, 'signupAt' | 'lastUpdatedAt' | 'profileCompletionStatus' | 'id' | 'firstName' | 'avatar'>
  ) }
);
